import { combineReducers } from 'redux';
import emailReducer from './email/reducer';
import permissionsEmailBannerReducer from './permissionsEmailBanner/reducer';
import { EMAIL_STATE_NAME, PERMISSIONS_EMAIL_BANNER } from './constants';

export default combineReducers({
  [EMAIL_STATE_NAME]: emailReducer,
  [PERMISSIONS_EMAIL_BANNER]: permissionsEmailBannerReducer,
});



// WEBPACK FOOTER //
// ./app/Alerts/reducer.js